import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { MroCVEApiService } from '../mro-cve-api.service';
import { MroCVERepository } from '../mro-cve.repository';
import { MroCVEApiServiceMock } from '@mocks/mro-cve-api-mock.service';

export const HTTP_MRO_CVE_SERVICE = new InjectionToken<MroCVERepository>('MroCVERepository');

export const MRO_CVE_API_PROVIDER: Provider = {
    provide: HTTP_MRO_CVE_SERVICE,
    useClass: environment.useMocks && environment.useMocks.mroCVE ? MroCVEApiServiceMock : MroCVEApiService,
};
